import { addModal } from 'weblite-web-modal-viewer'
import {
  BuyPremiumFeatureDialog,
  BuyPremiumFeatureDialogProps,
} from './buy-premium-feature-dialog'

const COMPONENT_ID = 'buyPremiumFeatureDialog'

export const showBuyPremiumFeatureDialog = (
  props: Exclude<BuyPremiumFeatureDialogProps, 'isOpen'>,
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: BuyPremiumFeatureDialog,
  },
}
